export const DP_POSITION = '1100040000370018';
